import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { detAllSearch } from "../Redux/slices/searchSlice";
import { useDispatch, useSelector } from "react-redux";
import { clearMessage, fetchResourceDetail, submitResourceForm, updateResource } from "../Redux/slices/detailSlice";
import { useNavigate, useParams } from "react-router-dom";

const UploadContainer = styled.div`
  /* display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  padding: 30px;
  border-radius: 15px;
  background: #ffffff;
  border: 1px solid #1b2a501a;
  width: 420px;

  h3 {
    color: #1b2a50;
    font-size: 18px;
    font-weight: 600;
  }
  @media (max-width: 500px) {
    width: 320px;

  }
  @media (max-width: 360px) {
    width: 270px;

  }  */
`;

const DropZone = styled.div`
  width: 425px;
  height: 160px;
  border: 1px solid #1b2a501f;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: #ffffff;
  cursor: pointer;
  transition: border-color 0.3s;

  &:hover {
    border-color: #0056b3;
  }
  @media (max-width: 500px) {
    width: 257px;
  }
  @media (max-width: 360px) {
    width: 200px;
  }
`;

const UploadIcon = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #5a5a5a;

  svg {
    width: 40px;
    height: 40px;
    fill: #0056b3;
  }

  p {
    color: #565e6f;
    font-size: 14px;
    font-weight: 400;
  }
`;

const UploadButton = styled.button`
  width: 357px;
  height: 48px;
  font-size: 18px;
  font-weight: 600;
  color: white;
  background: #2d81eb;
  border: none;
  border-radius: 7px;
  border: 1px solid #2d81eb;
  cursor: pointer;
  transition: background 0.3s;

  &:hover {
    background: #0056b3;
  }
  @media (max-width: 500px) {
    width: 257px;
  }
  @media (max-width: 360px) {
    width: 200px;
  }
`;

const FileName = styled.p`
  font-size: 14px;
  color: #333;
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* ✅ Semi-transparent background */
  backdrop-filter: blur(5px); /* ✅ Blurred background */
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalContent = styled.div`
  background: white;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  width: 300px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  h3 {
    font-size: 24px;
    font-weight: 600px;
  }
  button {
    color: #ffffff;
    font-size: 14px;
    font-weight: 600;
    border-style: none;
    width: 120px;
    height: 40px;
    border-radius: 10px;
  }
`;

const DocumentRap = styled.div`
  .doc-header h4 {
    color: #1b2a50;
    font-size: 18px;
    font-weight: 600;
  }
  .doc-header {
    padding: 20px;
    border-bottom: 1px solid #1b2a501f;
  }
  .page-div {
    width: 40px;
    height: 40px;
    border-bottom: 1px solid #1b2a501f;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: white;
  }
  .page-div p {
    font-size: 14px;
    font-weight: 600;
    color: #565e6f;
  }
  .page-div.active {
    background: #2d81eb;
  }
  .page-div.active p {
    color: #ffffff;
  }
  .span-line {
    width: 120px;
    border: 1px solid #1b2a501f;
  }
  .span-line.active {
    border: 1px solid #2d81eb;
  }

  .pages-check {
    display: flex;
    align-items: center;
    gap: 10px;
    justify-content: center;
    margin-bottom: 30px;
  }
  .doc-form-divs label {
    color: #565e6f;
    font-size: 16px;
    font-weight: 600;
    max-width: 425px;
    line-height: 24px;
  }
  .doc-form-divs input,
  .doc-form-divs select {
    border: 1px solid #1b2a501f;
    border-radius: 10px;
    width: 500px;
    height: 47px;
    padding: 0px 20px;
    background: #ffffff;
  }
  .input-div {
    border: 1px solid #1b2a501f;
    border-radius: 10px;
    width: 500px;
    height: 47px;
    display: flex;
    background: #ffffff;
    font-size: 12px;
    font-weight: 600;
    color: #565e6f;

    align-items: center;
    justify-content: space-between;
    padding: 0px 20px;
  }
  .checkinput {
    border: 1px solid #1b2a501f;
    border-radius: 10px;
    width: 400px;
    height: 47px !important;
    background: #ffffff;
    font-size: 12px;
    font-weight: 600;
    color: #565e6f;
    padding: 20px 10px;
    margin-left: 20px;
    margin-bottom: 20px;
  }
  .doc-form-divs {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .doc-body {
    padding: 20px;
    background: #f7f7f7;
    margin: 20px;
    border-radius: 8px;
  }
  .document {
    border: 1px solid #1018281a;
    background: #ffffff;
    border-radius: 8px;
  }
  .all-document-div {
    padding-top: 50px;
    padding-bottom: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .all-page-one button {
    width: 100%;
    height: 47px;
    border-radius: 10px;
    border-style: none;

    color: #ffffff;
    font-size: 16px;
    font-weight: 600;
  }
  .all-page-one {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .resource-drop label {
    color: #1b2a50;
    font-size: 16px;
    font-weight: 400;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    gap: 5px;
  }

  .resource-drop {
    background: #ffffff;
    border: 1px solid #1b2a501a;
    box-shadow: 0px 8px 22px 0px #1b2a501f;
    border-radius: 12px;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 5px;
    position: absolute;
    max-height: 200px;
    overflow-y: auto;
    z-index: 1000;
  }
  .duration-text {
    color: blue;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
  }
  .duration-div-pop {
    background: #ffffff;
    padding: 20px;
    border-radius: 15px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
  }
  .duration-div-pop button {
    border: 1px solid black;
    border-radius: 7px;
    background: transparent;
    color: black;
    font-size: 14px;
    font-weight: 500;
  }
`;

const EditDocument = () => {
  const resourceOptions = [
    "Articles",
    "Activity / Event",
    "Affinity Group / Club / Organization",
    "Assessment",
    "Award / Recognition",
    "Campaign / Awareness",
    "Center / Institute",
    "Collaboration/Partnership",
    "Committee / Council / Task Force",
    "Conference / Forum / Symposium",
    "Course / Class / Curricula-Related",
    "Books",
    "Dissertation / Thesis",
    "Education / Training",
    "Initiative / Practice",
    "Media (social media, website, video, etc.)",
    "Mentoring",
    "Personnel / Office",
    "Policies / Procedures",
    "Program",
    "Publication",
    "Research",
    "Services / Support",
    "Other",
  ];
  const categoryOptions = [
    "Academic Organizations",
    "Non-Profit Organization",
    "Faith-Based Organizations",
    "Student Organization",
    "Healthcare Organizations",
    "Corporations",
    "Advocacy andOutreach Organizations",
    "Cultural Organizations",
    "Others",
  ];
  const GroupOptions = [
    "Ability Status",
    "Age",
    "Culture",
    "Different Ideas and Perspectives",
    "Ethnicity",
    "First Generation Status",
    "Familial Status",
    "Gender Identity and Expression",
    "Geographic Background",
    "Marital Status",
    "National Origin",
    "Race",
    "Religious/Spiritual Beliefs",
    "Sex",
    "Sexual Orientation",
    "Socioeconomic Status",
    "Veteran Status",
    "Others",
  ];
  const reciSphere = [
    "Recognizing Racing Oppression and Advancing Racial Liberation",
    "Examining Racial Identities and Addressing Racial Biases",
    "Embracing Racial Empathy and Enhancing Racial Literacy",
    "Building Racial Empathy and Enhancing Racial Stamina",
    "Acknowledging Racial Trauma and Fostering Racial Healing",
    "Gauging Racial Inequities & Championing Racial Justice",
  ];
  const sustainableGroup = [
    "No poverty",
    "No Hunger",
    "Good Health & Well-Being",
    "Quality Education",
    "Gender Equality",
    "Clean Water & Sanitation",
    "Affordable & Clean Energy",
    "Decent Work & Economic Growth",
    "Industry, Innovation, & Infrastructure",
    "Reduced Inequalities",
    "Sustainable Cities & Communities",
    "Responsible Consumption & Production",
    "Climate Action",
    "Life Below Water",
    "Life On Land",
    "Peace, Justice, & Strong Institutions",
    "Partnerships For The Goal",
  ];
  const dispatch = useDispatch();
const navigate = useNavigate()
const { id } = useParams(); // Get ID from URL
const {updateMessage, resources, totalPages, resource, status, reportSuccess } =
useSelector((state) => state.resource);
const resourceData = resource?.data?.resources

  const [activeLink, setActiveLink] = useState("pageOne");
  const [resourseDrop, setResourceDrop] = useState(false);
  const [categoryDrop, setCategoryDrop] = useState(false);
  const [groupDrop, setGroupDrop] = useState(false);
  const [racialDrop, setRacialDrop] = useState(false);
  const [sustainableDrop, setSustainableDrop] = useState(false);

  const [selectedResources, setSelectedResources] = useState([resourceData?.resource_type]);
  const [selectedGroups, setSelectedGroups] = useState([resourceData?.resource_identity_group]);
  const [selectedRacial, setSelectedRacial] = useState([resourceData?.racial_equality_consciousness]);
  const [selectedSustainable, setSelectedSustainable] = useState([resourceData?.sustainable_development_goals]);

  const [selectedCategory, setSelectedCategory] = useState([resourceData?.resource_category]); // Store multiple selections
  const [file, setFile] = useState(null);
  const [otherResource, setOtherResource] = useState(""); // Track "Other" input
  // const { data, error } = useSelector((state) => state.search);
  const { summitLoading, message, loading, success, error } = useSelector(
    (state) => state.resource
  );




  const [showDatePop, setShowDatePop] = useState(false);
console.log(updateMessage);

  console.log(resourceData);

  const [formData, setFormData] = useState({
    resourceType: [resourceData?.resource_type],
    startDate: resourceData?.startdate,
    resourceContactTitle: resourceData?.contant_title,
    resourceOrganization: resourceData?.contant_organization,
    endDate: resourceData?.enddate,
    resourceTitle: resourceData?.resource_title,
    resourceDescription: resourceData?.resource_description,
    resourceCategory: [resourceData?.resource_category],
    identityGroup: [resourceData?.resource_identity_group],
    racialSphere: [resourceData?.racial_equality_consciousness],
    sustainable: [resourceData?.sustainable_development_goals],
    targetAudience: resourceData?.resource_type,
    yearResource: resourceData?.year_initiated,
    status: resourceData?.resource_status,
    weblink: resourceData?.resource_link,
    uploadedFile: resourceData?.file,
  });
  const resourceId = id;

  console.log(formData);

   useEffect(() => {
      dispatch(fetchResourceDetail(resourceId));
    }, [dispatch, resourceId]);




  const handleSustainableDrop = () => {
    setSustainableDrop(!sustainableDrop);
  };
  const handleCategoryDrop = () => {
    setCategoryDrop(!categoryDrop);
  };
  const handleGroupDrop = () => {
    setGroupDrop(!groupDrop);
  };
  const handleRacialDrop = () => {
    setRacialDrop(!racialDrop);
  };

  useEffect(() => {
    dispatch(detAllSearch()); // Call API on component mount
  }, [dispatch]);

  const isValid =
    // formData.resourceType.length > 0 && // Check if at least one checkbox is selected
    formData.resourceTitle.trim() !== "" &&
    formData.resourceContactTitle.trim() !== "" &&
    formData.resourceOrganization.trim() !== "" &&
    // formData.resourceCategory.length > 0 &&
    formData.resourceDescription.trim() !== "";

  const handleNext = () => {
    if (isValid) {
      setActiveLink("pageTwo");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileUpload = (event) => {
    const uploadedFile = event.target.files[0];
    if (uploadedFile) {
      setFile(uploadedFile); // Update file state
      setFormData((prevData) => ({
        ...prevData,
        uploadedFile: uploadedFile, // Also update formData with the file
      }));
    }
  };

  const handleCheckboxChange = (resource) => {
    setSelectedResources((prevSelected) => {
      let updatedSelection;

      if (prevSelected.includes(resource)) {
        updatedSelection = prevSelected.filter((item) => item !== resource);
      } else {
        updatedSelection = [...prevSelected, resource];
      }

      // Update form data, but exclude "Other"
      setFormData((prev) => ({
        ...prev,
        resourceType: updatedSelection.filter((item) => item !== "Other"), // Remove "Other"
      }));

      return updatedSelection;
    });
  };

  const handleOtherInputKeyDown = (e) => {
    if (e.key === "Enter" && otherResource.trim() !== "") {
      e.preventDefault();

      setSelectedResources((prevSelected) => {
        // Remove "Other" & Add only new custom values
        const updatedSelection = [
          ...prevSelected.filter((r) => r !== "Other"),
          otherResource.trim(),
        ];

        return [...new Set(updatedSelection)];
      });

      // Update form data with only user-entered values
      setFormData((prev) => ({
        ...prev,
        resourceType: [
          ...new Set([...prev.resourceType, otherResource.trim()]),
        ],
      }));

      setOtherResource(""); // Clear input field
    }
  };

  const handleCheckboxCategory = (resource) => {
    setSelectedCategory((prevSelected) => {
      let updatedSelection;
      if (prevSelected.includes(resource)) {
        // Remove if already selected
        updatedSelection = prevSelected.filter((item) => item !== resource);
      } else {
        // Add if not selected
        updatedSelection = [...prevSelected, resource];
      }

      // Update form data
      setFormData((prev) => ({
        ...prev,
        resourceCategory: updatedSelection,
      }));

      return updatedSelection;
    });
  };
  const handleCheckboxGroup = (resource) => {
    setSelectedGroups((prevSelected) => {
      let updatedSelection;
      if (prevSelected.includes(resource)) {
        // Remove if already selected
        updatedSelection = prevSelected.filter((item) => item !== resource);
      } else {
        // Add if not selected
        updatedSelection = [...prevSelected, resource];
      }

      // Update form data
      setFormData((prev) => ({
        ...prev,
        identityGroup: updatedSelection,
      }));

      return updatedSelection;
    });
  };
  const handleCheckboxRacial = (resource) => {
    setSelectedRacial((prevSelected) => {
      let updatedSelection;
      if (prevSelected.includes(resource)) {
        // Remove if already selected
        updatedSelection = prevSelected.filter((item) => item !== resource);
      } else {
        // Add if not selected
        updatedSelection = [...prevSelected, resource];
      }

      // Update form data
      setFormData((prev) => ({
        ...prev,
        racialSphere: updatedSelection,
      }));

      return updatedSelection;
    });
  };
  const handleCheckboxSustainable = (resource) => {
    setSelectedSustainable((prevSelected) => {
      let updatedSelection;
      if (prevSelected.includes(resource)) {
        // Remove if already selected
        updatedSelection = prevSelected.filter((item) => item !== resource);
      } else {
        // Add if not selected
        updatedSelection = [...prevSelected, resource];
      }

      // Update form data
      setFormData((prev) => ({
        ...prev,
        sustainable: updatedSelection,
      }));

      return updatedSelection;
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(updateResource({ id: resourceId, formData }));
  };

  const handleClose = () => {
    dispatch(clearMessage()); 
    navigate("/users/dashboard")
  };

  const handleResourceDrop = () => {
    setResourceDrop(!resourseDrop);
  };
  return (
    <DocumentRap>
      <div className="all-document-div">
        <div className="document">
          <div className="doc-header">
            <h4>Upload Document</h4>
          </div>
          <div className="all-doc-body">
            <div className="doc-body">
              <div className="pages-check">
                <div
                  className={
                    activeLink === "pageOne" || activeLink === "pageTwo"
                      ? "page-div active"
                      : "page-div"
                  }
                >
                  <p>01</p>
                </div>
                <span
                  className={
                    activeLink === "pageTwo" ? "span-line active" : "span-line"
                  }
                ></span>
                <div
                  className={
                    activeLink === "pageTwo" ? "page-div active" : "page-div"
                  }
                >
                  <p>02</p>
                </div>
              </div>
              <div>
                {activeLink === "pageOne" && (
                  <div className="all-page-one">
                    {/* <div className="doc-form-divs">
                      <label>Resource Contact Name:</label>
                      <input
                        type="text"
                        name="resourceContactName"
                        value={formData.resourceContactName}
                        onChange={handleChange}
                      />
                    </div> */}

                    <div className="doc-form-divs">
                      <label>Resource Contact Title:</label>
                      <input
                        type="text"
                        name="resourceContactTitle"
                        value={formData.resourceContactTitle}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="doc-form-divs">
                      <label>
                        Resource Contact Organization/Department/Division
                        (please list full name, e.g.: Office for Equity,
                        Diversity, and Inclusion, Swanson School of Engineering,
                        College of General Studies, University Center for
                        Teaching and Learning, Department of Sociology, etc.):
                      </label>
                      <input
                        type="text"
                        name="resourceOrganization"
                        value={formData.resourceOrganization}
                        onChange={handleChange}
                      />
                    </div>

                    {/* <div className="doc-form-divs">
                      <label>Resource Contact Email:</label>
                      <input
                        type="email"
                        name="resourceContactEmail"
                        value={formData.resourceContactEmail}
                        onChange={handleChange}
                      />
                    </div> */}

                    <div className="doc-form-divs">
                      <label>Resource Title:</label>
                      <input
                        type="text"
                        name="resourceTitle"
                        value={formData.resourceTitle}
                        onChange={handleChange}
                      />
                    </div>
                    <p
                      className="duration-text"
                      onClick={() => setShowDatePop(true)}
                    >
                      What is the duration of your research?
                    </p>
                    {showDatePop ? (
                      <div className="dropdown-container">
                        <div className="duration-div-pop">
                          <div className="doc-form-divs">
                            <label>Start Date:</label>
                            <input
                              type="date"
                              name="startDate"
                              value={formData.startDate}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="doc-form-divs">
                            <label>End Date:</label>
                            <input
                              type="date"
                              name="endDate"
                              value={formData.endDate}
                              onChange={handleChange}
                            />
                          </div>
                          <button onClick={() => setShowDatePop(false)}>
                            Close
                          </button>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}

                    <div className="doc-form-divs">
                      <label>Resource Description:</label>
                      <input
                        type="text"
                        name="resourceDescription"
                        value={formData.resourceDescription}
                        onChange={handleChange}
                      />
                    </div>

                    <div style={{ position: "relative" }}>
                      <div className="doc-form-divs">
                        <label>Resource Type:</label>
                        <div onClick={handleResourceDrop} className="input-div">
                          {selectedResources.length > 0
                            ? selectedResources.join(", ") // Show all selected resources
                            : "Select Resource Type"}
                          <Icon
                            className="icon"
                            width="16px"
                            height="16px"
                            icon="ep:arrow-down"
                            style={{ color: "#565E6F80", marginLeft: "10px" }}
                          />
                        </div>
                      </div>

                      {resourseDrop && (
                        <div className="resource-drop">
                          {resourceOptions.map((resource, index) => (
                            <label key={index}>
                              <input
                                type="checkbox"
                                checked={selectedResources.includes(resource)}
                                onChange={() => handleCheckboxChange(resource)}
                              />
                              {resource}
                            </label>
                          ))}

                          {/* Show input field when "Other" is checked */}
                          {selectedResources.includes("Other") && (
                            <input
                              className="checkinput"
                              type="text"
                              value={otherResource}
                              onChange={(e) => setOtherResource(e.target.value)}
                              onKeyDown={handleOtherInputKeyDown} // Capture Enter key press
                              placeholder="Type and press Enter"
                            />
                          )}
                        </div>
                      )}
                    </div>

                    <div style={{ position: "relative" }}>
                      <div className="doc-form-divs">
                        <label>Resource Category:</label>
                        <div onClick={handleCategoryDrop} className="input-div">
                          {selectedCategory.length > 0
                            ? selectedCategory.join(", ") // Show selected resources
                            : "Select Resource Category"}
                          <Icon
                            className="icon"
                            width="16px"
                            height="16px"
                            icon="ep:arrow-down"
                            style={{ color: "#565E6F80", marginLeft: "10px" }}
                          />
                        </div>
                      </div>

                      {categoryDrop && (
                        <div className="resource-drop">
                          {categoryOptions.map((resource, index) => (
                            <label key={index}>
                              <input
                                type="checkbox"
                                checked={selectedCategory.includes(resource)}
                                onChange={() =>
                                  handleCheckboxCategory(resource)
                                }
                              />
                              {resource}
                            </label>
                          ))}
                        </div>
                      )}
                    </div>
                    <button
                      disabled={!isValid}
                      style={{
                        backgroundColor: isValid
                          ? "#2d81eb"
                          : "rgb(159, 187, 221)",
                        cursor: !isValid ? "not-allowed" : "pointer",
                      }}
                      onClick={handleNext}
                    >
                      Next
                    </button>
                  </div>
                )}
                {activeLink === "pageTwo" && (
                  <>
                    <div className="all-page-one">
                      <div style={{ position: "relative" }}>
                        <div className="doc-form-divs">
                          <label>
                            Which Identity Groups Does The Resource Support?
                            (select all that apply):
                          </label>
                          <div onClick={handleGroupDrop} className="input-div">
                            {selectedGroups.length > 0
                              ? selectedGroups.join(", ") // Show selected resources
                              : "Select "}
                            <Icon
                              className="icon"
                              width="16px"
                              height="16px"
                              icon="ep:arrow-down"
                              style={{ color: "#565E6F80", marginLeft: "10px" }}
                            />
                          </div>
                        </div>

                        {groupDrop && (
                          <div className="resource-drop">
                            {GroupOptions.map((resource, index) => (
                              <label key={index}>
                                <input
                                  type="checkbox"
                                  checked={selectedGroups.includes(resource)}
                                  onChange={() => handleCheckboxGroup(resource)}
                                />
                                {resource}
                              </label>
                            ))}
                          </div>
                        )}
                      </div>

                      <div style={{ position: "relative" }}>
                        <div className="doc-form-divs">
                          <label>
                            Which UN Sustainable Development Goals does the
                            resource impact? (select all that apply)
                          </label>
                          <div
                            onClick={handleSustainableDrop}
                            className="input-div"
                          >
                            {selectedSustainable.length > 0
                              ? selectedSustainable.join(", ") // Show selected resources
                              : "Select "}
                            <Icon
                              className="icon"
                              width="16px"
                              height="16px"
                              icon="ep:arrow-down"
                              style={{ color: "#565E6F80", marginLeft: "10px" }}
                            />
                          </div>
                        </div>

                        {sustainableDrop && (
                          <div className="resource-drop">
                            {sustainableGroup.map((resource, index) => (
                              <label key={index}>
                                <input
                                  type="checkbox"
                                  checked={selectedSustainable.includes(
                                    resource
                                  )}
                                  onChange={() =>
                                    handleCheckboxSustainable(resource)
                                  }
                                />
                                {resource}
                              </label>
                            ))}
                          </div>
                        )}
                      </div>

                      <div style={{ position: "relative" }}>
                        <div className="doc-form-divs">
                          <label>
                            Which Racial Equity Consciousness spheres of
                            development does the resource advance? (select all
                            that apply
                          </label>
                          <div onClick={handleRacialDrop} className="input-div">
                            {selectedRacial.length > 0
                              ? selectedRacial.join(", ") // Show selected resources
                              : "Select "}
                            <Icon
                              className="icon"
                              width="16px"
                              height="16px"
                              icon="ep:arrow-down"
                              style={{ color: "#565E6F80", marginLeft: "10px" }}
                            />
                          </div>
                        </div>

                        {racialDrop && (
                          <div className="resource-drop">
                            {reciSphere.map((resource, index) => (
                              <label key={index}>
                                <input
                                  type="checkbox"
                                  checked={selectedRacial.includes(resource)}
                                  onChange={() =>
                                    handleCheckboxRacial(resource)
                                  }
                                />
                                {resource}
                              </label>
                            ))}
                          </div>
                        )}
                      </div>

                      <div className="doc-form-divs">
                        <label>Target Audience</label>
                        <input
                          type="text"
                          name="targetAudience"
                          value={formData.targetAudience}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="doc-form-divs">
                        <label>Year Resource was Initiated:</label>
                        <input
                          type="email"
                          name="yearResource"
                          value={formData.yearResource}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="doc-form-divs">
                        <label>Resource Status:</label>
                        <select
                          name="status"
                          value={formData.status}
                          onChange={handleChange}
                        >
                          <option>Select</option>
                          <option value="One-Time">One-Time</option>
                          <option value="Periodic">Periodic</option>
                          <option value="Ongoing">Ongoing</option>
                        </select>
                      </div>

                      <div className="doc-form-divs">
                        <label>Resource Weblink (if applicable):</label>
                        <input
                          type="text"
                          name="weblink"
                          value={formData.weblink}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="doc-form-divs">
                        <label>Resource Attachment (if applicable):</label>
                        <UploadContainer>
                          <DropZone>
                            <label htmlFor="file-upload">
                              <UploadIcon>
                                <img src="/images/img-1.png" alt="" />
                                <p>Drop files or click here to upload</p>
                              </UploadIcon>
                            </label>
                            <input
                              id="file-upload"
                              type="file"
                              style={{ display: "none" }}
                              onChange={handleFileUpload}
                            />
                          </DropZone>

                          {file && <FileName>{file.name}</FileName>}
                        </UploadContainer>
                      </div>
                      <button
                        onClick={handleSubmit}
                        //  disabled={!isValid}
                        style={{
                          backgroundColor: "#2d81eb",
                          //    cursor:  !isValid ? "not-allowed" : "pointer",
                        }}
                      >
                        {summitLoading ? "Saving..." : "Continue"}
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {message && (
        <ModalOverlay>
          <ModalContent>
            <h3>Success 🎉</h3>
            <p>{message}</p>
            <button
              style={{
                backgroundColor: "#0067D0",
              }}
              onClick={handleClose}             >
              Continue
            </button>
          </ModalContent>
        </ModalOverlay>
      )}
    </DocumentRap>
  );
};

export default EditDocument;
